// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"69d23fce","596":"8240f611"}[chunkId] + ".chunk.js";
};